module.exports = __webpack_public_path__ + "img/nomontor.f52c2fa2.png";